import { PencilIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ROUTES from '@/ROUTES'
import { format } from 'date-fns'

import { IKnowledge } from '@/MODELS/knowledge.model'

import { useResource } from '@/services/resource.service'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'
import ConfirmModal from '@/components/ConfirmModal'
import Table from '@/components/Table'

export default function AdminKnowledgeBaseTable() {
    const navigate = useNavigate()
    const [knowledgeBase, setKnowledgeBase, KnowledgeResource] = useResource<IKnowledge[]>(ROUTES.admin.knowledge)
    const [deleteKnowledgeId, setDeleteKnowledgeId] = useState<string | null>(null)

    return (
        <div className='flex flex-col w-full max-w-7xl gap-5 py-10 mx-auto'>
            <AdminPageHeader
                heading={'AI Context & Knowledge Management'}
                subheading='Control the context and information your AI chat uses to provide answers to users'
                className='py-5'
                action={<Button onClick={() => navigate('/admin/knowledge/new')}> Add Knowledge </Button>}
            />
            <Table
                data={knowledgeBase ?? []}
                columns={[
                    {
                        header: 'Title',
                        cell: (knowledge) => <div className='max-w-[250px] truncate'>{knowledge.title}</div>,
                    },

                    {
                        header: 'Content',
                        cell: (knowledge) => <div className='max-w-[250px] truncate'>{knowledge.content}</div>,
                    },
                    {
                        header: 'Metadata',
                        cell: (knowledge) => <div className='max-w-[250px] truncate'>{knowledge.metadata}</div>,
                    },

                    {
                        header: '',
                        cell: (knowledge) => (
                            <Link
                                to={`/admin/knowledge/${knowledge._id}`}
                                className='transition-opacity hover:opacity-70'
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                <PencilIcon className='w-6 h-6 shrink-0' />
                            </Link>
                        ),
                    },
                    {
                        header: '',
                        cell: (knowledge) => (
                            <>
                                <Button.Trash
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        console.log(knowledge._id)
                                        setDeleteKnowledgeId(knowledge._id)
                                    }}
                                />
                            </>
                        ),
                    },
                ]}
            />

            <ConfirmModal
                open={!!deleteKnowledgeId}
                onCancel={() => setDeleteKnowledgeId(null)}
                onConfirm={async () => {
                    await KnowledgeResource.deleteById(deleteKnowledgeId)
                    await KnowledgeResource.get()
                    setDeleteKnowledgeId(null)
                }}
                title='Delete Resource'
                description='Are you sure you want to delete this resource? This action cannot be undone.'
                confirmText='Delete'
                cancelText='Cancel'
                intent='danger'
            />
        </div>
    )
}
